import { render, staticRenderFns } from "./BandanaBox.vue?vue&type=template&id=b0b0a636&scoped=true&"
import script from "./BandanaBox.vue?vue&type=script&lang=ts&"
export * from "./BandanaBox.vue?vue&type=script&lang=ts&"
import style0 from "./BandanaBox.vue?vue&type=style&index=0&id=b0b0a636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b0a636",
  null
  
)

export default component.exports